// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-rr31","left":"styles_left__d8waL","desktopActions":"styles_desktopActions__grah3","title":"styles_title__2Rl2y"};